import React, { useEffect, useState } from 'react';
import SettingsLayout from './SettingsLayout';
import { canAccessSettingsSection, getDefaultSettingsSection } from '../../lib/permissions';

function Setting({
  setActiveItem,
  initialSection,
  onConsumeInitialSection,
}: {
  setActiveItem: (item: string) => void;
  initialSection?: string | null;
  onConsumeInitialSection?: () => void;
}) {
  const [activeSection, setActiveSection] = useState(() => getDefaultSettingsSection());

  useEffect(() => {
    if (!initialSection) return;
    if (canAccessSettingsSection(initialSection)) {
      setActiveSection(initialSection);
    }
    onConsumeInitialSection?.();
  }, [initialSection, onConsumeInitialSection]);

  const handleSectionChange = (section: string) => {
    setActiveSection(section);
  };

  return (
    <SettingsLayout activeSection={activeSection} onSectionChange={handleSectionChange} setActiveItem={setActiveItem} />
  );
}

export default Setting;